'use client';

import { c as _c } from "react/compiler-runtime";
import './sac-empty.scss';
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { LogoEmptySearch } from '@sola/ark-core/logos/empty-search.tsx';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
interface SacEmptyProps {
  resetFilters?: () => void;
  hideAssistedCtas?: boolean;
}
export const SacEmpty: React.FC<FlexibleContentProps & SacEmptyProps> = t0 => {
  const $ = _c(27);
  const {
    resetFilters,
    hideAssistedCtas: t1
  } = t0;
  const hideAssistedCtas = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["children"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="display-block margin-right-auto margin-left-auto"><LogoEmptySearch aria-hidden={true} /></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t) {
    t4 = t("children:sac.resetTitle");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <h2 className="display display-md">{t4}</h2>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t) {
    t6 = t("children:sac.resetMessage");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <p className="body body-md">{t6}</p>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <div>{t3}{t5}{t7}</div>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t("children:sac.resetFilters");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== resetFilters || $[16] !== t9) {
    t10 = <ButtonStyle><button onClick={resetFilters} className="w-full md:w-fit" type="button">{t9}</button></ButtonStyle>;
    $[15] = resetFilters;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== hideAssistedCtas || $[19] !== t) {
    t11 = !hideAssistedCtas && <ButtonStyle variant="secondary" purpose="neutral"><Link href="/sponsor-a-child/child-bio" className="w-full md:w-fit">{t("children:sac.selectAChildForMe")}</Link></ButtonStyle>;
    $[18] = hideAssistedCtas;
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <div className="flex flex-col md:flex-row gap-comfy-xs items-center justify-center">{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t8) {
    t13 = <div className="SacEmpty text-center gap-comfy-lg">{t8}{t12}</div>;
    $[24] = t12;
    $[25] = t8;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};